module.exports = __webpack_public_path__ + "static/media/proba.b8a6131a.png";